import React from 'react';

// Match http(s)://, www., or bare domains like example.com / forms.gle/...
const URL_REGEX = /(https?:\/\/[^\s<]+[^\s<.,!?:;'")\]])|(www\.[^\s<]+[^\s<.,!?:;'")\]])/gi;

/**
 * Render plain text with any URLs converted into clickable links that open in a new tab.
 * Preserves whitespace/newlines via whitespace-pre-wrap on the parent.
 */
const Linkify = ({ text, className = '' }) => {
  if (!text) return null;

  const parts = [];
  let lastIndex = 0;
  let match;
  let key = 0;

  while ((match = URL_REGEX.exec(text)) !== null) {
    const raw = match[0];
    const start = match.index;

    if (start > lastIndex) {
      parts.push(text.slice(lastIndex, start));
    }

    const href = raw.startsWith('http') ? raw : `https://${raw}`;
    parts.push(
      <a
        key={`lk-${key++}`}
        href={href}
        target="_blank"
        rel="noopener noreferrer"
        className="text-primary hover:text-primary-dark underline break-words"
      >
        {raw}
      </a>
    );

    lastIndex = start + raw.length;
  }

  if (lastIndex < text.length) {
    parts.push(text.slice(lastIndex));
  }

  return <span className={className}>{parts}</span>;
};

export default Linkify;
